<template>
  <div class="tags-wrap" :class="{
        'tags--has-tags': hasTags
      }">
    <af-h3 v-if="hasTags">Dina val</af-h3>
    <div
      class="tags">
      <search-tag
        v-for="tag in tags"
        :key="`${tag.type}-${tag.path}` + (tag.value !== undefined ? `-${tag.value}`: '')"
        :tag="tag">
      </search-tag>

      <button
        v-if="hasTags"
        class="tags__reset"
        @click="resetQuery">
        <icon class="tags__reset-icon" fill="white" :size="16" type="undo"></icon>
        Rensa alla val
      </button>
    </div>
  </div>
</template>

<script>
import SearchTag from './SearchTag'
import { RESET_QUERY } from '@/store/actionTypes'
import Icon from '@/components/Icon'
import AfH3 from '@/components/AfH3'

export default {
  name: 'SearchTags',

  components: {
    AfH3,
    Icon,
    SearchTag
  },

  props: {
    tags: {
      required: true,
      type: Array
    }
  },

  computed: {
    hasTags() {
      return this.tags.length > 0
    }
  },

  methods: {
    resetQuery() {
      this.$store.commit(RESET_QUERY)
      window.eventBus.$emit('RESET_QUERY')
    }
  }
}
</script>

<style lang="postcss" scoped>
.tags {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: var(--spacing-third);
  margin-top: var(--spacing-third);

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    margin-bottom: var(--spacing-third);
  }
}

.tags--has-tags {
  margin-bottom: var(--spacing-third);
  margin-top: var(--spacing);
}

.tags__reset {
  align-items: center;
  appearance: none;
  background-color: var(--color-medium-carmine);
  border: 0;
  border-radius: 3px;
  color: var(--color-white);
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: bold;
  padding: var(--spacing-third);
  position: relative;
  margin-bottom: var(--spacing-third);

  &:not(:last-child) {
    margin-right: var(--spacing-third);
  }

  @supports (-ms-ime-align: auto) {
    &:not(:last-child) {
      margin-bottom: var(--spacing-third);
    }
  }
}

.tags__reset-icon {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchTags.vue